import {API_URL} from '../../app/tenant/apiBase'

export const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname

// Offer/catalog image paths from the partner-portal API come back relative to
// the OpenCart image directory (e.g. "data/PartnerPortal/.../x.webp"), which is
// served at {API_HOST}/image/<path>. This panel now runs on a different origin
// (Cloudflare Pages) than the API, so a bare relative path resolves against the
// panel domain and 404s. Build the absolute URL against the API host, adding the
// "image/" segment when missing. Values that are already absolute
// (http/https/data/blob) or already include the "image/" prefix pass through.
export const toCatalogImageUrl = (url?: string | null): string => {
  if (!url) return ''
  if (/^(https?:)?\/\//i.test(url) || url.startsWith('data:') || url.startsWith('blob:')) return url
  const base = API_URL || ''
  const path = url.replace(/^\/+/, '')
  return `${base}/${path.startsWith('image/') ? '' : 'image/'}${path}`
}
